import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import { ReactComponent as ClearIcon } from '@doveconviene/sf-ui/icons/ico_close.svg'
import Icon from '../../../ui/Icon'

const StyledTitle = styled.span(({ theme: { colors } }) => ({
  flex: '1 1 auto',
  color: colors.primary,
  cursor: 'pointer',
}))

const StyledClearIcon = styled.div(({ theme }) => ({
  color: theme.colors.primary,
  cursor: 'pointer',
  flex: '0 0 auto',
  width: '20px',
  height: '20px',
  marginRight: '8px',
  '& use': {
    fill: theme.colors.primary,
  },
}))

const StyledClearFilterButton = styled.button(() => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '0px',
  margin: '0px',
  border: '0px',
  fontSize: '14px',
  background: 'white',
}))

const ClearFilterButton = ({ label, onClick }) => (
  <StyledClearFilterButton
    onClick={onClick}
    data-test="ClearFilterButton"
  >
    <StyledClearIcon>
      <Icon>
        <ClearIcon />
      </Icon>
    </StyledClearIcon>
    <StyledTitle>
      { label }
    </StyledTitle>
  </StyledClearFilterButton>
)

ClearFilterButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
}

ClearFilterButton.defaultProps = {
  onClick: () => false,
  label: '',
}

ClearFilterButton.displayName = 'ClearFilterButton'
ClearFilterButton.whyDidYouRender = true

export default React.memo(ClearFilterButton)
